export default __webpack_public_path__ + "cdee8b447e9e3e9a0973dabd2cf451e4.png";